import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { InvoiceItem, InvoiceItemCreate, InvoiceItemFilter } from '../data/invoiceItem';

export function createInvoiceItemService(client: AxiosInstance) {
  return createCrudService<InvoiceItem, InvoiceItemCreate, InvoiceItemFilter>(
    client,
    '/InvoiceItem',
    'invoiceItemId'
  );
}

export type InvoiceItemService = CrudService<InvoiceItem, InvoiceItemCreate, InvoiceItemFilter>;
